import { useMutation, useQuery, useQueryClient } from 'react-query';
import CatalogItemAPI from '../Api/catalog-item';

export const useGetUserCatalogItems = (userId, params) =>
  useQuery(['catalog-items', userId, params], () =>
    CatalogItemAPI.getCatalogItems(userId, params),
  );

export const useMutateItem = () => {
  const queryClient = useQueryClient();
  const urlParams = Object.fromEntries(
    new URLSearchParams(window.location.search),
  );

  if (urlParams.sortBy) {
    urlParams.sortBy = urlParams.sortBy.split(',');
  }

  const queryParams = {
    page: +urlParams.page,
    offset: +urlParams.offset,
    limit: +urlParams.limit,
    sortBy: urlParams.sortBy,
    sortOrder: urlParams.sortOrder,
    styleNumber: urlParams.styleNumber,
  };

  return useMutation({
    mutationFn: (variables) => {
      const { currentUserId, itemUpdate } = variables;
      return CatalogItemAPI.updateCatalogItem(
        currentUserId,
        itemUpdate.id,
        itemUpdate,
      );
    },
    onMutate: async (variables) => {
      const thisQuery = [
        'catalog-items',
        variables.currentUserId.toString(),
        queryParams,
      ];
      // Cancel current queries for items list
      await queryClient.cancelQueries({
        queryKey: thisQuery,
      });

      const oldItems = await queryClient.getQueryData(thisQuery);

      const updatedItems = oldItems ? [...oldItems.items] : [];
      const index = updatedItems.findIndex(
        (item) => item.id === variables.itemUpdate.id,
      );

      // optimistically update item
      if (index !== -1) {
        updatedItems[index] = {
          ...updatedItems[index],
          ...variables.itemUpdate,
        };
        queryClient.setQueryData(thisQuery, {
          items: updatedItems,
          count: oldItems.count,
        });
      }

      return { variables, oldItems, updatedItems };
    },
    onError: (err, newItem, context) => {
      // rollback on error
      queryClient.setQueryData(
        ['catalog-items', context.currentUserId.toString(), queryParams],
        context.oldItems,
      );
    },
  });
};

export const useMutateItems = () => {
  const queryClient = useQueryClient();

  queryClient.setMutationDefaults(['update-items'], {
    mutationFn: (variables) => {
      const { currentUser, params } = variables;
      return CatalogItemAPI.bulkUpdateCatalogItem(currentUser, params);
    },
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  return useMutation(['update-items']);
};
